import React from 'react'

import Navigation from './../../landing/components/Nav'
import Blogs from './../../landing/components/Blog'
import Footer from './../../landing/components/Footer'


const Blog = props => {
	return (
		<>
			<Navigation />
			<Blogs />
			<Footer />
		</>
	)
}

export default Blog